import React, { useState, useEffect } from 'react';

/**
 * 回到顶部按钮组件
 * 当用户向下滚动超过300px时显示一个按钮，点击可平滑滚动回顶部
 * 注意：这与ScrollToTopOnMount组件不同，后者在路由变化时自动滚动
 */
const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // 监听滚动事件，控制按钮显示/隐藏
  const toggleVisibility = () => {
    // 直接使用window.pageYOffset来确定滚动位置
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    setIsVisible(scrollY > 300);
  };

  // 滚动到顶部的函数
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    // 添加滚动事件监听器
    window.addEventListener('scroll', toggleVisibility);
    
    // 组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    isVisible && (
      <button
        onClick={scrollToTop}
        aria-label="回到顶部"
        className="fixed bottom-6 right-6 z-40 bg-slate-600 text-white rounded-full p-3 hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-400 shadow-lg transition-all duration-300"
      >
        <svg 
          className="w-5 h-5" 
          viewBox="0 0 20 20" 
          fill="currentColor"
        >
          <path 
            fillRule="evenodd" 
            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" 
            clipRule="evenodd" 
          />
        </svg>
      </button>
    )
  );
};

export default ScrollToTop; 